module.exports = __webpack_public_path__ + "img/denise.02e63958.jpg";